import { render, staticRenderFns } from "./ConfigureBundle.vue?vue&type=template&id=32cfb636&scoped=true"
import script from "./ConfigureBundle.vue?vue&type=script&lang=ts"
export * from "./ConfigureBundle.vue?vue&type=script&lang=ts"
import style0 from "./ConfigureBundle.vue?vue&type=style&index=0&id=32cfb636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cfb636",
  null
  
)

export default component.exports